import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CheckRegularReport from './check-regular-report-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CheckRegularReport {...validProps} />;
}

SvgComponent.iconName = 'checkRegularReport';

export const CheckRegularReportIcon = svgIconWrapper(SvgComponent);
